import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { privateRoutes } from '@routes/privateRoutes';
import { publicRoutes } from '@routes/publicRoutes';

const APP_NAME = 'Borrower Portal';

const allRoutes = [...privateRoutes, ...publicRoutes];

export const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;

    let route = allRoutes.find(r => r.path === pathname);

    if (!route) {
      route = allRoutes.find(r => {
        const routePattern = r.path.replace(/:[^/]+/g, '[^/]+');
        const regex = new RegExp(`^${routePattern}$`);
        return regex.test(pathname);
      });
    }

    if (route?.title) {
      document.title = route.title;
    } else {
      // Fallback for unknown routes
      document.title = APP_NAME;
    }
  }, [location.pathname]);
};
